import { Collapse } from 'antd';
import styled from 'styled-components';

export default styled(Collapse)`
	// Add your styles here
`;

// ?? This should be move to custom folder
const PanelWrapper = styled(Collapse.Panel)`
	.ant-collapse-content-box {
		padding: 8px 12px !important;
	}
`;

export { PanelWrapper };